import { fetch } from "./API";

export const FetchDashboardHealth = async () => {
  try {
    return await fetch(`${process.env.REACT_APP_API_URL}/dashboard/health`);
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
